export interface WindowsApplicationState {
	applications: string[];
	areApplicationsSet: boolean;
}

export function createWindowsApplicationState(): WindowsApplicationState {
	return { applications: [], areApplicationsSet: false };
}
